package ai.beakman.undercover.web

import ai.beakman.undercover.i18n.I18n
import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.ContentBuilder
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLDivElement

/** Cabeçalho do app: título + tagline (espelha o UndercoverHeader do shared). */
@Composable
fun Header() {
    val s = I18n.strings
    Div({ classes("app-header") }) {
        Div({ classes("app-logo") }) {
            Span({ classes("logo-text") }) { Text(s.webBrandTitle) }
        }
        Div({ classes("app-tagline") }) { Text(s.webBrandTagline) }
    }
}

@Composable
fun PrimaryButton(text: String, enabled: Boolean = true, onClick: () -> Unit) {
    Button({
        classes("btn-primary")
        if (!enabled) disabled()
        onClick { onClick() }
    }) { Text(text) }
}

@Composable
fun SecondaryButton(text: String, enabled: Boolean = true, onClick: () -> Unit) {
    Button({
        classes("btn-secondary")
        if (!enabled) disabled()
        onClick { onClick() }
    }) { Text(text) }
}

@Composable
fun BackLink(text: String, onClick: () -> Unit) {
    Button({
        classes("back-link")
        onClick { onClick() }
    }) { Text("← $text") }
}

@Composable
fun Label(text: String) {
    Div({ classes("label") }) { Text(text) }
}

@Composable
fun MutedText(text: String) {
    Div({ classes("muted") }) { Text(text) }
}

/** Wrapper de input de texto com a classe .input do design system. */
@Composable
fun TextField(
    value: String,
    placeholder: String = "",
    onInput: (String) -> Unit,
) {
    Input(InputType.Text) {
        classes("input")
        value(value)
        placeholder(placeholder)
        onInput { event -> onInput(event.value) }
    }
}

/** Card padrão do design system (fundo --card, raio 20px). */
@Composable
fun CardBox(content: ContentBuilder<HTMLDivElement>) {
    Div({ classes("card") }, content)
}

/** Barra de progresso de etapas do setup (step de 1..total). */
@Composable
fun StepIndicator(step: Int, total: Int = 3) {
    Div({ classes("steps") }) {
        repeat(total) { i ->
            Div({
                classes("step")
                if (i < step) classes("done")
            })
        }
    }
}

/** Top bar de partida: label centralizado + "✕ Sair" à direita. */
@Composable
fun GameTopBar(label: String, onExit: () -> Unit) {
    Div({ classes("game-topbar") }) {
        Label(label)
        Button({
            classes("exit")
            onClick { onExit() }
        }) { Text(I18n.strings.exitSair) }
    }
}

/** Formata segundos como "m:ss" (ex.: 180 → "3:00"). */
fun formatTime(seconds: Int): String {
    val m = seconds / 60
    val s = seconds % 60
    return "$m:${s.toString().padStart(2, '0')}"
}
